const page = state => state.page
const pages = state => state.pages
const subnav = state => state.subnav

export default {
  page,
  pages,
  subnav
}
